import { useMemo } from 'react'
import { useUser } from '@fs/zion-user'
import { getIsChild } from '../../helpers/family_helper'

export default function useFamilyGroupCard(familyGroups) {
  const { userLoading, birthDate } = useUser()

  const { cardType, targetFamilyGroup } = useMemo(() => {
    if (userLoading) {
      return {} // User data not loaded yet
    }
    if (familyGroups !== null && !Array.isArray(familyGroups)) {
      return {} // Family groups not loaded yet
    }
    // familyGroups is null (no groups) or an array at this point
    if (!familyGroups || familyGroups.length === 0) {
      const isChild = getIsChild(birthDate)
      if (isChild)
        // They are under 18 and have no family groups → ask a parent to create a family group
        return { cardType: 'ask-parent' }

      // They have no Family Groups → Create a family group card
      return { cardType: 'create-group' }
    }

    const groupsWithAdmin = familyGroups.filter((group) => group.memberStatus === 'ADMIN')

    if (groupsWithAdmin.length === 0) {
      if (familyGroups.some((group) => group.memberStatus === 'PENDING')) {
        // They are a pending member of one or more groups → Pending card
        return { cardType: 'pending' }
      }

      const nonTreeGroup = familyGroups.find((group) => !group.types.includes('PRIVATE_PERSON_SHARING'))
      // They are member of a group with tree sharing enabled → NOTHING!
      if (nonTreeGroup === undefined) return {}

      // They are a part of a non-tree group but not the admin → Ask admin to change the settings
      return { cardType: 'not-admin-enable-group-tree', targetFamilyGroup: nonTreeGroup }
    }

    const adminNonTreeGroup = groupsWithAdmin.find((group) => !group.types.includes('PRIVATE_PERSON_SHARING'))
    if (adminNonTreeGroup) {
      // They are admin of a non-tree sharing group → Change group settings
      return { cardType: 'enable-group-tree', targetFamilyGroup: adminNonTreeGroup }
    }

    const smallGroup = groupsWithAdmin.find((group) => group.memberCount < 5)
    if (smallGroup) {
      // They are Admin of a familyGroup with < 5 members → Invite family group members
      return { cardType: 'invite-members', targetFamilyGroup: smallGroup }
    }

    // They are admin of a group with > 5 members → NOTHING!
    return {}
  }, [userLoading, birthDate, familyGroups])

  return { cardType, targetFamilyGroup }
}
